import { COMPANY_URL } from "../../constants/apiUrls";
import { apiSlice } from "../apiSlice";

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    supportTicket: builder.mutation({
      query: ({ data, token }) => ({
        url: `${COMPANY_URL}/support/`,
        method: "POST",
        body: data,
      }),
      /* The viewer's own record carries the ticket list Help & Support
         renders, so raising one makes it stale. The screen also appends the
         new ticket locally, which kept it on screen but not across a
         navigation away and back. */
      invalidatesTags: ["User"],
    }),
  }),
});

export const { useSupportTicketMutation } = adminApiSlice;
